import { api } from "./client";
import type { Paginated, Task, TaskPriority, TaskStatus } from "./types";

export interface TaskCreatePayload {
  employee_id: string;
  shop_ids: string[];
  title: string;
  description?: string;
  priority?: TaskPriority;
  assigned_date?: string;
  due_date?: string | null;
}

export const tasksApi = {
  list: (params: Record<string, unknown> = {}) =>
    api.get<Paginated<Task>>("/tasks/", { params }).then((r) => r.data),
  // The create endpoint fans one payload out into one task per shop, so it
  // returns an array.
  create: (payload: TaskCreatePayload) =>
    api.post<Task[]>("/tasks/", payload).then((r) => r.data),
  update: (id: string, payload: Partial<Task>) =>
    api.patch<Task>(`/tasks/${id}/`, payload).then((r) => r.data),
  setStatus: (id: string, status: TaskStatus) =>
    api.patch<Task>(`/tasks/${id}/status/`, { status }).then((r) => r.data),
  remove: (id: string) => api.delete(`/tasks/${id}/`),
};
